import React, { Component } from "react";
import { connect } from "react-redux";

import { getLoggedInUser } from "../helpers/authUtils";
import CrudBar from "../gb-components/CrudBar";
import PreLoaderWidget from "../components/Loader";
import { getProfByAssistente } from "../Libs/assistente.js";
import { Col, Row } from "reactstrap";
import { setOpenChatAssistente } from "../redux/default/actions.js";
import { sleep } from "../helpers/utils.js";


class AssistenteMedicos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: getLoggedInUser(),
      profissionais: null,
      profSelected: "",
      loading: true,
    };
  }

  async componentDidMount() {
    console.log(this.state.user)
    this.setState({ loading: true })
    const profissionais = await getProfByAssistente(this.state.user.cpf)
    this.setState({ profissionais, loading: false })
  }

  getChat(medico) {
    this.props.openChatAssistente(medico)
  }

  render() {
    return (
      <React.Fragment>
        <div className="gb-cont-page">
          <CrudBar
            title="Médicos Conversas"
            breadcrumb={["Globalbrain", "Médicos Conversas"]}
          />

          <div className="gb-page">
            {this.state.loading ? (<div className="text-center"><PreLoaderWidget /></div>) :
              <React.Fragment>

                {this.state.profissionais && this.state.profissionais.length === 0 &&
                  <Row>
                    <Col md={12}>
                      <p className="p-4 text-center" style={{ fontSize: 16 }}>Você não pode ver conversas de nenhum médico</p>
                    </Col>
                  </Row>
                }

                {this.state.profissionais
                  && this.state.profissionais.length > 0 ?
                  <div className="table-responsive">
                    <table className="table gb-table">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Nome</th>
                          <th scope="col">Profissão</th>
                          <th scope="col">Telefone</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.profissionais.map(
                          (item, index) => {
                            return (
                              <tr key={index} onClick={() => this.getChat(item)} style={{ cursor: "pointer" }} className="linkEdit">
                                <td scope="row" className="text-center">{index + 1}</td>
                                <td className="text-center">{item.nome}</td>
                                <td className="text-center">{item.profissao}</td>
                                <td className="text-center">{item.telefone ? item.telefone : item.whatsapp}</td>
                              </tr>
                            )
                          }
                        )}
                      </tbody>
                    </table>
                  </div>
                  : null}

              </React.Fragment>
            }
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    openChatAssistente: async (medico) => {
      dispatch(setOpenChatAssistente(medico))
      await sleep(200)
      dispatch(setOpenChatAssistente(null))
    }
  }
};

export default connect(null, mapDispatchToProps)(AssistenteMedicos);
